import type { EntityConfigDefinition, DisplayColumnConfig } from '../../types/entityConfig'
import { TABLE_PRODUCT } from '../../utils/displayFormatters'

const config: EntityConfigDefinition = {
  name: 'APPLICATION_PRODUCT',
  idField: 'APPLICATION_PRODUCT_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['APPLICATION_PRODUCT_ID'],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['APPLICATION_ID'],
    stringMatchFields: ['APPLICATION_ID'],
    stringMatchThreshold: 0.50,
    displayFields: ['APPLICATION_PRODUCT_ID', 'APPLICATION_ID', 'ORIGIN_PRODUCT_ID', 'INSTANCE_NBR', 'PROCESS_FLAG', 'CREATED_DATE', 'CHANGED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Foreign key lookups
  foreignKeys: {
    "APPLICATION_ID": {
      "table": "APPLICATION",
      "valueField": "APPLICATION_ID",
      "displayField": "APPLICATION_NAME"
    },
    "ORIGIN_PRODUCT_ID": {
      "table": "ORIGIN_PRODUCT",
      "valueField": "ORIGIN_PRODUCT_ID",
      "displayField": "PRODUCT_ID"
    }
  },
  
  // Field lookups for display enhancement
  fieldLookups: {
    "APPLICATION_ID": {
      "lookupTable": "APPLICATION",
      "foreignKey": "APPLICATION_ID",
      "displayField": "APPLICATION_NAME",
      "displayFormat": "{APPLICATION_ID}: {APPLICATION_NAME}"
    },
    "ORIGIN_PRODUCT_ID": {
      "lookupTable": "ORIGIN_PRODUCT",
      "foreignKey": "ORIGIN_PRODUCT_ID",
      "displayField": "PRODUCT_ID",
      "displayFormat": TABLE_PRODUCT
    }
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'APPLICATION_ID',
      lookup: {
        table: 'APPLICATION',
        foreignKey: 'APPLICATION_ID',
        displayField: 'APPLICATION_NAME'
      }
    },
    {
      field: 'ORIGIN_PRODUCT_ID',
      lookup: {
        table: 'ORIGIN_PRODUCT',
        foreignKey: 'ORIGIN_PRODUCT_ID',
        displayField: 'PRODUCT_ID'
      }
    }
  ] as DisplayColumnConfig[],

  // Fields configuration
  fields: [
    "APPLICATION_PRODUCT_ID",
    "APPLICATION_ID",
    "ORIGIN_PRODUCT_ID",
    "INSTANCE_NBR",
    "PROCESS_FLAG",
    "CREATED_DATE",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "APPLICATION_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "ORIGIN_PRODUCT_ID",
      "type": "select",
      "required": true,
      "disabled": false,
      "options": []
    },
    {
      "name": "INSTANCE_NBR",
      "type": "number",
      "required": true,
      "disabled": false
    },
    {
      "name": "PROCESS_FLAG",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    },
    {
      "name": "CHANGED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

